<template>
  <div v-bind:class="{ 'header header__black': this.black, 'header header__white': !this.black }">
    <!--<span>-->
      <ul>
        <li v-for="pom in poms" :key="pom">{{pom}}</li>
      </ul>

  </div>
    <!--</sp an>-->
</template>

<script>
export default {
  name: 'POMS',
  data: function () {
    return {
      // searchKeyword: this.term,
      showFilters: false,
      isAsc: true,
      sort: 'desc'
    }
  },
  props: ['black', 'poms']
}
</script>

<style scoped>
div {
  z-index: 1000;
}

ul {
  list-style-type: none;
}
</style>



// WEBPACK FOOTER //
// src/components/POMS.vue